// import axios from 'axios'
// import { MessageBox, Message } from 'element-ui'
// import store from '@/store'
// import { getToken } from '@/utils/auth'

// // create an axios instance
// const service = axios.create({
//   baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
//   // withCredentials: true, // send cookies when cross-domain requests
//   timeout: 25000, // 请求超时时间
// })

// // request拦截器
// service.interceptors.request.use(
//   config => {
//     // do something before request is sent

//     if (store.getters.token) {
//       // 让每个请求携带自定义token 请根据实际情况自行修改
//       config.headers.userToken = getToken()
//     }
//     return config
//   },
//   error => {
//     // do something with request error
//     console.log(error) // for debug
//     return Promise.reject(error)
//   },
// )

// // response 拦截器
// service.interceptors.response.use(
//   response => {
//     const res = response.data

//     // code为非1时抛错 可结合自己业务进行修改
//     if (res.code !== 1) {
//       Message({
//         message: res.message || 'Error',
//         type: 'error',
//         duration: 5 * 1000,
//       })

//       // 991:缺少必要的参数; 992:缺少必要的token; 993:不合法的token;
//       if (res.code === 991 || res.code === 992 || res.code === 993) {
//         response.config.showErrorMsg && MessageBox.confirm('会话超时，请重新登录', {
//           confirmButtonText: '重新登录',
//           cancelButtonText: '取消',
//           type: 'warning',
//         }).then(() => {
//           store.dispatch('user/resetToken').then(() => {
//             location.reload() // 为了重新实例化vue-router对象 避免bug
//           })
//         })
//       } else {
//         response.config.showErrorMsg && Message({
//           message: res.message + (res.data ? '：' + res.data : ''),
//           type: 'error',
//           showClose: true,
//           duration: 5 * 1000,
//         })
//       }
//       return Promise.reject(new Error(res.message || 'Error'))
//     } else {
//       return res
//     }
//   },
//   error => {
//     console.log('err' + error) // for debug
//     Message({
//       message: error.message,
//       type: 'error',
//       showClose: true,
//       duration: 5 * 1000,
//     })
//     return Promise.reject(error)
//   },
// )

// export default service

import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import router from '@/router'
import { getToken } from '@/utils/auth'
import qs from 'qs'

axios.defaults.transformRequest = [function (data, headers) {
  const contentType = headers['Content-Type'] || ''
  if (contentType.includes('json')) {
    return typeof data === 'string' ? data : JSON.stringify(data)
  } else {
    return qs.stringify(data)
  }
}]

const toLogin = function () {
  MessageBox.confirm('会话超时，请重新登录', {
    confirmButtonText: '重新登录',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    store.dispatch('FedLogOut').then(() => {
      router.push(`/login?redirect=${router.currentRoute.fullPath}`)
      // location.reload()// 为了重新实例化vue-router对象 避免bug
    })
  }).catch(_ => _)
}

const showMessage = function (msg) {
  Message({
    message: msg,
    type: 'error',
    showClose: true,
    duration: 5 * 1000,
  })
}

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api的base_url
  timeout: 25000, // 请求超时时间
  // withCredentials: false, // 允许携带cookie
  headers: {
    'Content-Type': 'application/json'
  },
  // headers: {
  //   'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
  // },
})

// request拦截器
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (getToken()) {
      // 让每个请求携带自定义token 请根据实际情况自行修改
      config.headers.Authorization = 'Bearer ' + getToken()
      // console.log(config)
    }
    return config
  },
  error => {
    console.log(error) // for debug
    // do something with request error
    return Promise.reject(error)
  },
)

// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (Object.prototype.hasOwnProperty.call(res, 'code') && res.code !== 1) {
      if (res.code === 991 || res.code === 992 || res.code === 993) {
        toLogin()
      } else if (res.code === 999) {
        return Promise.reject(res)
      } else {
        showMessage(res.message)
        return Promise.reject(res)
      }
    } else {
      return response.data.data
    }
    return response.data.data
  },
  error => {
    if (error.response.status === 401) {
      toLogin()
    }
    showMessage(error)
    return Promise.reject(error)
  },
)
export default service
